import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/upload/uploadFile';
import { biddingUploadResults, getTaskInfo, searchWinBidSupplier } from '../../api';
import { createBiddingSupplierRow, createUnitedServiceSupplier, normalizeCustomerId } from './applyForm/utils/taskData';
export default {
  name: 'BiddingResultDialog',
  components: {
    UploadFile: UploadFile
  },
  data: function data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      form: {
        item_id: null,
        status: '',
        reason: '',
        suppliers: [],
        announcement: [],
        bid_opening_remarks: ''
      },
      rules: {
        status: [{
          required: true,
          message: '请选择开标结果',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请选择优联未中标原因',
          trigger: 'change'
        }],
        suppliers: [{
          validator: function validator(rule, value, callback) {
            for (var i = 0; i < (value || []).length; i++) {
              if (!(value[i].company_name || '').trim()) {
                callback(new Error('请填写供应商名称'));
                return;
              }
              if (!(value[i].price || '').trim()) {
                callback(new Error('请填写报价'));
                return;
              }
            }
            callback();
          },
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    announcementImageSrcList: function announcementImageSrcList() {
      var _this = this;
      return this.form.announcement.filter(function (item) {
        return _this.isImageFile(item);
      }).map(function (item) {
        return _this.$ossurl + item.url;
      });
    }
  },
  methods: {
    open: function open(itemId) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, detail, taskStatus, supplier;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.form.item_id = itemId;
              _this2.form.status = '';
              _this2.form.reason = '';
              // 默认第一个供应商：优联服务，不可修改
              _this2.form.suppliers = [createUnitedServiceSupplier()];
              _this2.form.announcement = [];
              _this2.form.bid_opening_remarks = '';
              _this2.dialogVisible = true;
              _context.n = 1;
              return getTaskInfo({
                item_id: itemId
              });
            case 1:
              res = _context.v;
              detail = res.data || {}; // 开标结果：600已交付归一到550已中标（本弹窗无交付结果字段）
              taskStatus = String(detail.task_status || '');
              _this2.form.status = Number(taskStatus) === 600 ? '550' : taskStatus;
              _this2.form.reason = String(detail.reason || '');
              supplier = _this2.parseList(detail.supplier); // supplier 的 name 已拆分为 company_name/customer_id：
              // 旧数据回填旧名称，customer_id 非空的行补进下拉选项保证回显
              _this2.form.suppliers = supplier.length ? supplier.map(function (item, index) {
                var companyName = item.company_name || item.name || (index === 0 ? '优联服务' : '');
                var customerId = normalizeCustomerId(item.customer_id) || (index === 0 ? '296' : '');
                return _objectSpread(_objectSpread({}, item), {}, {
                  company_name: companyName,
                  customer_id: customerId,
                  options: customerId ? [{
                    id: customerId,
                    company_name: companyName
                  }] : [],
                  is_win: String(item.is_win) === '1' || item.is_win === true
                });
              }) : [createUnitedServiceSupplier()];
              _this2.form.announcement = _this2.parseList(detail.announcement);
              _this2.form.bid_opening_remarks = detail.bid_opening_remarks || '';
              if (_this2.form.status === '550' && _this2.form.suppliers[0]) {
                _this2.form.suppliers[0].is_win = true;
              }
              _this2.$nextTick(function () {
                _this2.$refs.form.clearValidate();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 兼容接口返回数组或JSON字符串
    parseList: function parseList(val) {
      if (Array.isArray(val)) return val;
      if (typeof val === 'string' && val) {
        try {
          return JSON.parse(val);
        } catch (_) {
          return [];
        }
      }
      return [];
    },
    changeBidResult: function changeBidResult() {
      if (this.form.status === '500') {
        this.form.reason = '';
      }
      this.form.suppliers[0].is_win = this.form.status === '550';
    },
    isWinDisabled: function isWinDisabled(index) {
      return index === 0 && (this.form.status === '500' || this.form.status === '550');
    },
    addSupplier: function addSupplier() {
      if (this.form.suppliers.length >= 20) return;
      this.form.suppliers.push(createBiddingSupplierRow());
    },
    // 参标供应商远程搜索：结果替换选项列表，已选中项补回保证回显
    searchSupplierOptions: function searchSupplierOptions(keyword, supplier) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, list, selectedId;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return searchWinBidSupplier({
                keyword: (keyword || '').trim()
              });
            case 1:
              res = _context2.v;
              list = (res.data || []).map(function (item) {
                return {
                  id: String(item.id),
                  company_name: item.company_name
                };
              });
              selectedId = normalizeCustomerId(supplier.customer_id);
              if (selectedId && !list.some(function (item) {
                return item.id === selectedId;
              })) {
                list.unshift({
                  id: selectedId,
                  company_name: supplier.company_name
                });
              }
              supplier.options = list;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 选中时同步供应商名称；清空时一并清掉，避免旧名称继续参与提交
    changeSupplierOption: function changeSupplierOption(supplier, id) {
      var option = (supplier.options || []).find(function (item) {
        return item.id === id;
      });
      supplier.company_name = option ? option.company_name : '';
    },
    // 展开时按空关键字刷新默认列表，避免只剩已选项或上次搜索结果
    handleSupplierVisible: function handleSupplierVisible(visible, supplier) {
      if (visible) {
        this.searchSupplierOptions('', supplier);
      }
    },
    removeSupplier: function removeSupplier(index) {
      var _this3 = this;
      this.form.suppliers.splice(index, 1);
      this.$nextTick(function () {
        _this3.$refs.form.validateField('suppliers');
      });
    },
    isImageFile: function isImageFile(item) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      var fileExtension = (item.url || item.file_name || '').split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    isPdfFile: function isPdfFile(item) {
      var fileExtension = (item.url || item.file_name || '').split('.').pop().toLowerCase();
      return fileExtension === 'pdf';
    },
    openPdfFile: function openPdfFile(item) {
      window.open(this.$ossurl + item.url, '_blank');
    },
    handleAnnouncementUploaded: function handleAnnouncementUploaded(key, url, fileName, uid) {
      if (this.form.announcement.length >= 9) {
        this.$message.warning('最多支持上传9个文件');
        return;
      }
      this.form.announcement.push({
        file_name: fileName,
        url: key
      });
    },
    deleteAnnouncement: function deleteAnnouncement(index) {
      this.form.announcement.splice(index, 1);
    },
    downAnnouncement: function downAnnouncement(url, fileName) {
      this.$message.success('文件处理中…');
      var fullUrl = /^(https?:)?\/\//.test(url) ? url : this.$ossurl + url;
      var baseName = fileName || url.split('/').pop().split('?')[0];
      var ext = (url.split('?')[0].split('.').pop() || '').toLowerCase();
      var finalName = ext && !baseName.toLowerCase().endsWith('.' + ext) ? baseName + '.' + ext : baseName;
      fetch(fullUrl).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var objectUrl = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = finalName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      }).catch(function () {
        window.open(fullUrl, '_blank');
      });
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var obj = {
          item_id: _this4.form.item_id,
          status: _this4.form.status,
          // supplier[].is_win 按后端约定传字符串 '0'/'1'
          supplier: _this4.form.suppliers.map(function (item) {
            return {
              company_name: (item.company_name || '').trim(),
              customer_id: normalizeCustomerId(item.customer_id),
              price: (item.price || '').trim(),
              is_win: item.is_win ? '1' : '0'
            };
          }),
          announcement: _this4.form.announcement.map(function (_ref) {
            var file_name = _ref.file_name,
              url = _ref.url;
            return {
              file_name: file_name,
              url: url
            };
          }),
          bid_opening_remarks: _this4.form.bid_opening_remarks
        };
        // 开标结果=未中标时，提交未中标原因：1被废标 2未中标 3流标
        if (_this4.form.status === '500') {
          obj.reason = _this4.form.reason;
        }
        _this4.submitLoading = true;
        biddingUploadResults(obj).then(function () {
          _this4.$message.success('提交成功');
          _this4.dialogVisible = false;
          _this4.$emit('success');
        }).finally(function () {
          _this4.submitLoading = false;
        });
      });
    }
  }
};